import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import { ShimmerTable } from "react-shimmer-effects";
import InfoPill from "../InfoPill";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import moment from "moment";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePermissions } from "../contexts/PermissionContext";
import { SessionContext } from "../SessionProvider";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const StudentAddmissionList = (props) => {
  const { rolePermissions, userInfo } = usePermissions();

	  // select class option
  const [optionClasses, setOptionClasses] = useState([]);
  //select option
  const [optionSection, setOptionSection] = useState([]);
  
  const navigate = useNavigate();
  //vertical and HORIZONTAL dropdown
  const [orientation, setOrientation] = useState("vertical"); // "vertical" ya "horizontal"
  const [body, setBody] = useState();
  const canCreate = rolePermissions?.Students_Registration_List?.can_create;
  const { selectedSessionId, setSelectedSessionId, currentSessionId } =
    useContext(SessionContext);
  const [isCurrentSession, setIsCurrentSession] = useState();

  // State variables for class and section selection
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [isSectionEnabled, setIsSectionEnabled] = useState(false);
  const [filteredBody, setFilteredBody] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  // Class options
  const classOptions = [
    "Select class name",
    "NUR",
    "LKG",
    "HKG",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th-ARTS",
    "11th-COMM",
    "11th-Sci",
    "13th",
    "14th",
    "15th",
    "22th",
    "23th",
    "24th",
  ];

  // Section options
  const sectionOptions = ["Select section", "A", "B"];

  // useEffect(() => {
  //   async function init() {
  //     try {
  //       if (currentSessionId !== null && currentSessionId !== "undefined") {
  //         setIsCurrentSession(
  //           selectedSessionId === currentSessionId ? true : false,
  //         );
  //       }

  //       const result =
  //         await schoolApi.fetchStudentAddmission(selectedSessionId);
  //       if (result.success) {
  //         console.log("result is", result);
  //         setBody(result?.studentAddmision);
  //         setFilteredBody(result?.studentAddmision);
  //       }
  //     } catch (error) {
  //       setBody([]);
  //       setFilteredBody([]);
  //       return toast.error(error?.response?.data?.message);
  //     }
  //   }
  //   init();
  // }, [selectedSessionId, isCurrentSession]);
  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== "undefined") {
          setIsCurrentSession(
            selectedSessionId === currentSessionId ? true : false,
          );
        }

        // Student Admission List API
        const result =
          await schoolApi.fetchStudentAddmission(selectedSessionId);

        if (result.success) {
          console.log("result is", result);

          setBody(result?.studentAddmision);
          setFilteredBody(result?.studentAddmision);
        }

        // Dynamic Class API
        let classList = await schoolApi.getActiveClassRecords();

        if (classList?.result) {
          let ar = [];

          classList.result.forEach((item) => {
            ar.push({
              value: item.id,
              label: item.classname,
            });
          });

          setOptionClasses(ar);
        } else {
          setOptionClasses([]);
        }
      } catch (error) {
        setBody([]);
        setFilteredBody([]);
        setOptionClasses([]);

        return toast.error(error?.response?.data?.message);
      }
    }

    init();
  }, [selectedSessionId, isCurrentSession]);

  //class change
   const handleClassChange = async (e) => {
    const selectedClassValue = e.target.value;
    setSelectedClass(selectedClassValue);

    if (selectedClassValue === "") {
      setIsSectionEnabled(false);
      setSelectedSection("");
      setFilteredBody(body);
      setOptionSection([]);
      // toast.info("Please select a valid class");
    } else {
      setIsSectionEnabled(true);
      setSelectedSection("");

      try {
        // section fetch
        let sectionList =
          await schoolApi.getSectionRecordById(selectedClassValue);

        if (sectionList?.record && sectionList?.record?.length > 0) {
          let sectionOptions = sectionList.record.map((item) => ({
            value: item.name,
            label: item.name,
          }));

          setOptionSection(sectionOptions);
        } else {
          setOptionSection([]);
        }
      } catch (error) {
        setOptionSection([]);
      }

      if (body) {
        const selectedClassName =
          optionClasses.find((item) => item.value == selectedClassValue)
            ?.label || "";

        const filtered = body.filter((student) => {
          const className = student.student_info.class_name || "";
          return className === selectedClassName;
        });

        setFilteredBody(filtered);

        if (filtered.length === 0) {
          // toast.warning("No students found");
        } else {
          toast.success(`Found ${filtered.length} student(s)`);
        }
      }
    }

    setSelectedStudents([]);
  };

   const handleSectionChange = (e) => {
    const selectedSectionValue = e.target.value;
    setSelectedSection(selectedSectionValue);

    const selectedClassName =
      optionClasses.find((item) => item.value == selectedClass)?.label || "";

    if (selectedSectionValue === "") {
      const filtered = body.filter((student) => {
        const className = student.student_info.class_name || "";

        return (
          className.trim().toLowerCase() ===
          selectedClassName.trim().toLowerCase()
        );
      });

      setFilteredBody(filtered);
    } else {
      const filtered = body.filter((student) => {
        const className = student.student_info.class_name || "";
        const sectionName = student.student_info.section_name || "";

        return (
          className.trim().toLowerCase() ===
            selectedClassName.trim().toLowerCase() &&
          sectionName.trim().toLowerCase() ===
            selectedSectionValue.trim().toLowerCase()
        );
      });

      setFilteredBody(filtered);

      if (filtered.length === 0) {
        // toast.warning(
        //   `No students found in class ${selectedClassName} section ${selectedSectionValue}`,
        // );
      } else {
        // toast.success(`Found ${filtered.length} student(s)`);
      }
    }

    setSelectedStudents([]);
  };

  const handleSelectStudent = (studentId) => {
    setSelectedStudents((prev) => {
      if (prev.includes(studentId)) {
        return prev.filter((id) => id !== studentId);
      } else {
        return [...prev, studentId];
      }
    });
  };

  const handleSelectAll = () => {
    if (
      selectedStudents.length === filteredBody.length &&
      filteredBody.length > 0
    ) {
      setSelectedStudents([]);
    } else {
      setSelectedStudents(
        filteredBody.map(
          (student) => student.student_info.student_addmission_id,
        ),
      );
    }
  };

  // ==================== NEW ID CARD DESIGN (As per your image) ====================
  // Card size: 54mm x 85.6mm | 4 cards per row, 3 rows per page = 12 cards per page

  const createCardDiv = (student, orientation = "vertical") => {
    const studentInfo = student.student_info;

    const studentName = studentInfo.studentname || "N/A";
    const fatherName = studentInfo.parentname || "N/A";
    const registerDate = studentInfo.dateofbirth
      ? moment(studentInfo.dateofbirth).format("DD-MM-YYYY")
      : "N/A";
    const phone = studentInfo.parentmobile || studentInfo.phone || "N/A";
    const className = studentInfo.class_name || "";
    const sectionName = studentInfo.section_name || "";
    const fullClass = sectionName ? `${className} [${sectionName}]` : className;
    const session = studentInfo.session || "N/A";
    const registrationNo = studentInfo.registration_no || studentInfo.srno || "N/A";

    const div = document.createElement("div");

    // Orientation ke according width-height
    const isHorizontal = orientation === "horizontal";

    div.style.cssText = isHorizontal
      ? `
    width: 85.6mm;
    height: 54mm;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    border: 1px solid #d6d6d6;
    page-break-inside: avoid;
    break-inside: avoid;
  `
      : `
    width: 54mm;
    height: 85.6mm;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    border: 1px solid #d6d6d6;
    page-break-inside: avoid;
    break-inside: avoid;
  `;

    // Orientation ke according layout change
    if (isHorizontal) {
      // HORIZONTAL
      div.innerHTML = `
      <!-- HEADER -->
      <div style="width:100%; height:28%; background: linear-gradient(180deg,#114dc5,#2d6cf0); position:relative; color:white;">
        <!-- LOGO -->
        <div style="width:45px; height:45px; background:white; border-radius:50%; position:absolute; left:10px; top:8px; overflow:hidden; border:2px solid white;">
          <img src="/${userInfo?.tenantcode}-sidebar-logo.png" style="width:100%; height:100%; object-fit:cover; image-rendering: -webkit-optimize-contrast;" onerror="this.src='/uploads/dwps_ajmer/image_2024102442318.png'" />
        </div>
        <!-- SCHOOL NAME -->
        <div style="font-size:12px; font-weight:bold; padding: 5px 10px 0 60px; text-align:center; line-height:1.1;">${userInfo?.companyname || 'I Birds School'}</div>
        <div style="font-size:8px; text-align:center; padding: 0 10px 0 60px; line-height:1.1;">${userInfo?.companystreet || ''} ${userInfo?.companystate || ''} ${userInfo?.companypincode || ''}</div>
        <div style="font-size:8px; font-weight:bold; text-align:center; padding-left:60px;">${session}</div>
      </div>

      <!-- STUDENT IMAGE -->
     <div style="width:85px; height:85px; background:white; border:2px solid #2d6cf0; border-radius:50%; position:absolute; top:75px; left:12px; overflow:hidden;">

  <img
    src="${studentInfo?.file_id
          ? `/uploads/${studentInfo.file_parent_id}/${studentInfo.file_id}.${studentInfo.file_type}`
          : '/uploads/dwps_ajmer/image_2024102442318.png'
        }"
    alt="Profile"
    style="width:100%; height:100%; object-fit:cover;"
    onerror="this.src='/uploads/dwps_ajmer/image_2024102442318.png'"
  />

</div>

      <!-- REGISTRATION -->
      <div style="position:absolute; top:160px; left:22px; font-size:9px; font-weight:bold; color:#2d6cf0;">${registrationNo}</div>

      <!-- STUDENT NAME -->
      <div style="position:absolute; top:65px; left:115px; font-size:14px; font-weight:bold; color:#222;">${studentName}</div>

      <!-- DETAILS -->
     <div style="position:absolute; top:85px; left:115px; width:200px; font-size:10px; color:#222; line-height:1.8;">

  <div>
    <span style="font-weight:bold; display:inline-block; width:50px;">
      Father
    </span>
    : ${fatherName}
  </div>

  <div>
    <span style="font-weight:bold; display:inline-block; width:50px;">
      DOB
    </span>
    : ${registerDate}
  </div>

  <div>
    <span style="font-weight:bold; display:inline-block; width:50px;">
      Phone
    </span>
    : ${phone}
  </div>

  <div style="display:flex; gap:15px;">
    
    <div>
      <span style="font-weight:bold;">Class :</span>
      ${fullClass}
    </div>

    <div>
      <span style="font-weight:bold;">Blood Group:</span>
      <span style="font-weight:bold; margin-left:4px">-</span>
    </div>

  </div>

</div>

      <!-- FOOTER -->
      <div style="position:absolute; bottom:0; left:0; width:100%; display:flex; justify-content:space-between; align-items:center; background:#2d6cf0; padding:4px 8px; box-sizing:border-box; color:white; font-size:9px;">
        <div>+91-9339400600</div>
        <div>Principal Sign.</div>
      </div>
    `;
    } else {
      // VERTICAL
      div.innerHTML = `
      <!-- TOP BLUE HEADER -->
      <div style="height: 22%; background: linear-gradient(180deg,#114dc5,#2d6cf0); position: relative; color: white; text-align: center; padding-top: 3px;">
        <!-- Logo -->
        <div style="width: 42px; height: 42px; background: white; border-radius: 50%; position: absolute; left: 10px; top: 10px; overflow: hidden; border: 2px solid white;">
          <img src="/${userInfo?.tenantcode}-sidebar-logo.png" style="width: 100%; height: 100%; object-fit: cover; image-rendering: -webkit-optimize-contrast;" onerror="this.src='/uploads/dwps_ajmer/image_2024102442318.png'" />
        </div>
        <!-- School Details -->
        <div style="font-size: 11px; font-weight: bold; margin-top: 2px; padding: 0 5px 0 55px; text-align: center; line-height: 1.0;">${userInfo?.companyname || 'I Birds School'}</div>
        <div style="font-size: 7px; margin-top: 1px; padding: 0 5px 0 55px; text-align: center; line-height: 1.0;">${userInfo?.companystreet || ''} ${userInfo?.companystate || ''} ${userInfo?.companypincode || ''}</div>
        <div style="font-size: 8px; font-weight: bold; text-align: center; color: white; padding: 1px 5px 0 55px;">${session}</div>
      </div>

      <!-- WHITE CURVE -->
      <div style="position:absolute; top:24%; left:-10%; width:120%; height:30px; background:white;"></div>

      <!-- STUDENT IMAGE -->
      <div style="width: 95px; height: 95px; background: white; border: 2px solid #2d6cf0; border-radius: 50%; position: absolute; top: 75px; left: 26%; overflow: hidden;">

  <img
    src="${studentInfo?.file_id
          ? `/uploads/${studentInfo.file_parent_id}/${studentInfo.file_id}.${studentInfo.file_type}`
          : "/uploads/dwps_ajmer/image_2024102442318.png"
        }"
    style="width: 100%; height: 100%; object-fit: cover;"
    onerror="this.src='/uploads/dwps_ajmer/image_2024102442318.png'"
  />

</div>
      
      <div style="font-size: 8px; color: black; width: 100%; height: 18px; display: flex; justify-content: center; align-items: center; margin-top:102px;">${registrationNo}</div>
      
      <!-- STUDENT NAME -->
      <div style="text-align: center; font-size: 14px; font-weight: bold; color: #222;">${studentName}</div>

      <!-- DETAILS -->
      <div style="padding: 6px 10px; font-size: 8px; color:#222; line-height: 1.7;">
        <div style="display:flex; border-bottom:1px solid #ddd; padding:1px 0;">
          <div style="width:45%; font-weight:bold; font-size:10px;">Father's Name</div>
          <div style="width:55%; font-size:11px;"> :${fatherName}</div>
        </div>
        <div style="display:flex; border-bottom:1px solid #ddd; padding:1px 0;">
          <div style="width:45%; font-weight:bold; font-size:10px">D.O.B</div>
          <div style="width:55%; font-size:11px"> :${registerDate}</div>
        </div>
        <div style="display:flex; border-bottom:1px solid #ddd; padding:1px 0;">
          <div style="width:45%; font-weight:bold; font-size:10px">Contact No.</div>
          <div style="width:55%; font-size:11px">:${phone}</div>
        </div>
       <div style="display:flex; border-bottom:1px solid #ddd; padding:1px 0;">
  
  <span style="font-weight:bold;">Class :</span>
  <span style="margin-left:4px;">${fullClass}</span>

  <span style="font-weight:bold; margin-left:10px;">
    Blood Group:
  </span>

  <span style="margin-left:4px;">-</span>
</div>
        </div>
      </div>

      <!-- FOOTER -->
      <div style="position: absolute; bottom: 0; left: 0; width: 100%; display: flex; justify-content: space-between; align-items: center; background-color: #2d6cf0; padding: 4px 6px; box-sizing: border-box;">
        <div style="font-size: 9px; font-weight: bold; color: white;">+91-9339400600</div>
        <div style="font-size: 8px; color: white; text-align: right;">Principal Sign.</div>
      </div>
    `;
    }

    return div;
  };

  // ==================== PDF Generation Vertical(3x3 grid) Horizontal(2*3)====================

  const downloadIDCards = async (mode) => {
    // Priority mode from parameter, fallback to state
    const currentOrientation = mode || orientation;
    let studentsToDownload = [];

    if (selectedStudents.length > 0) {
      studentsToDownload = filteredBody.filter((student) =>
        selectedStudents.includes(student.student_info.student_addmission_id),
      );
    } else {
      studentsToDownload = filteredBody;
    }

    if (studentsToDownload.length === 0) {
      toast.warning("No students selected to download!");
      return;
    }

    setIsDownloading(true);

    try {
      //  ORIENTATION KE ACCORDING CARD DIMENSIONS
      const isHorizontal = currentOrientation === "horizontal";

      const CARD_WIDTH = isHorizontal ? 85.6 : 54;
      const CARD_HEIGHT = isHorizontal ? 54 : 85.6;
      const CARDS_PER_ROW = isHorizontal ? 2 : 3;
      const ROWS_PER_PAGE = isHorizontal ? 4 : 3;
      const CARDS_PER_PAGE = CARDS_PER_ROW * ROWS_PER_PAGE;

      const totalCards = studentsToDownload.length;
      const totalPages = Math.ceil(totalCards / CARDS_PER_PAGE);

      // Page dimensions in mm (A4)
      const PAGE_WIDTH = 210;
      const PAGE_HEIGHT = 297;

      const totalWidth = CARDS_PER_ROW * CARD_WIDTH + (CARDS_PER_ROW - 1) * 2;
      const marginLeft = (PAGE_WIDTH - totalWidth) / 2;
      const marginTop = 15;
      const spacingY = 2;

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      for (let pageNum = 0; pageNum < totalPages; pageNum++) {
        const startIdx = pageNum * CARDS_PER_PAGE;
        const endIdx = Math.min(startIdx + CARDS_PER_PAGE, totalCards);
        const cardsForThisPage = studentsToDownload.slice(startIdx, endIdx);

        const pageContainer = document.createElement("div");

        pageContainer.style.cssText = `
        width: ${PAGE_WIDTH}mm;
        min-height: ${PAGE_HEIGHT}mm;
        background: white;
        position: fixed;
        left: -99999px;
        top: 0;
        z-index: -1;
      `;
        const gridContainer = document.createElement("div");
        gridContainer.style.cssText = `
        position: relative;
        width: ${PAGE_WIDTH}mm;
      `;

        cardsForThisPage.forEach((student, idx) => {
          const card = createCardDiv(student, currentOrientation);
          const row = Math.floor(idx / CARDS_PER_ROW);
          const col = idx % CARDS_PER_ROW;

          const x = marginLeft + col * (CARD_WIDTH + 2);
          const y = marginTop + row * (CARD_HEIGHT + spacingY);

          card.style.position = "absolute";
          card.style.left = `${x}mm`;
          card.style.top = `${y}mm`;

          gridContainer.appendChild(card);
        });

        pageContainer.appendChild(gridContainer);
        document.body.appendChild(pageContainer);

        const canvas = await html2canvas(pageContainer, {
          scale: 3,
          backgroundColor: "#ffffff",
          logging: false,
          useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const imgWidth = PAGE_WIDTH;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (pageNum === 0) {
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        } else {
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        }

        document.body.removeChild(pageContainer);
      }

      pdf.save(
        `Student_ID_Cards_${currentOrientation}_${moment().format("DD-MM-YYYY")}.pdf`,
      );
      setSelectedStudents([]);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to generate ID cards");
    } finally {
      setIsDownloading(false);
    }
  };

  const header = [
    {
      title: (
        <input
          type="checkbox"
          checked={
            filteredBody.length > 0 &&
            selectedStudents.length === filteredBody.length
          }
          onChange={handleSelectAll}
          style={{
            cursor: "pointer",
            width: "18px",
            height: "18px",
          }}
        />
      ),
      prop: "selection",
      cell: (row) => (
        <div className="wasim">
          <input
            type="checkbox"
            checked={selectedStudents.includes(
              row.student_info.student_addmission_id,
            )}
            onChange={() =>
              handleSelectStudent(row.student_info.student_addmission_id)
            }
            style={{ cursor: "pointer", width: "18px", height: "18px" }}
          />
        </div>
      ),
    },
    {
      title: <span className="me-5 ">Student Name</span>,

      prop: "student_info.studentname",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <Link
          to={"/studentaddmissions/" + row.student_info.student_addmission_id}
          state={row}
        >
          {row.student_info.studentname}
        </Link>
      ),
    },
    {
      title: <span className="ms-2">Session</span>,
      prop: "student_info.session",
      isFilterable: true,
    },
    { title: "Parent", prop: "student_info.parentname", isFilterable: true },
    {
      title: "Parent Phone",
      prop: "student_info.parentmobile",
      isFilterable: true,
    },
    {
      title: "Class Name",
      prop: "student_info.class_name",
      cell: (row) =>
        `${row.student_info.class_name} [${row.student_info.section_name}]`,
      isFilterable: true,
    },
    { title: "Phone", prop: "student_info.phone", isFilterable: true },
    { title: "Email", prop: "student_info.email", isFilterable: true },
    {
      title: "Date Of Birth",
      prop: "student_info.dateofbirth",
      isFilterable: true,
      cell: (row) => moment(row.student_info.dateofbirth).format("DD-MM-YYYY"),
    },
    { title: "Registration ID", prop: "student_info.registration_no", isFilterable: true },
  ];

  const labels = {
    beforeSelect: " ",
  };

  const StudentAddmissionregistration = () => {
    navigate(`/student/registration`);
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>

      <Col lg={3} className="mx-4" style={{ marginTop: "18px" }}>
        <Link
          className="nav-link"
          to="/"
          style={{ marginLeft: "1px", marginRight: "1px" }}
        >
          Home <i className="fa-solid fa-chevron-right"></i> Students Addmission
        </Link>
      </Col>

      <Row className="g-0">
        <Col lg={12} className="px-lg-4">
          {body ? (
            <DatatableWrapper
              body={filteredBody}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={2}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
   <Col
                  xs={12}
                  lg={2}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <select
                    className="form-select"
                    value={selectedClass}
                    onChange={handleClassChange}
                    style={{ borderRadius: "5px", width: "100%" }}
                  >
                    {/* {classOptions.map((className, index) => (
                      <option key={index} value={className}>
                        {className}
                      </option>
                    ))} */}
                    <option value="">Select Class</option>

                    {optionClasses.map((className, index) => (
                      <option key={index} value={className.value}>
                        {className.label}
                      </option>
                    ))}
                  </select>
                </Col>

                <Col
                  xs={12}
                  lg={2}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <select
                    className="form-select"
                    value={selectedSection}
                    onChange={handleSectionChange}
                    disabled={!isSectionEnabled}
                    style={{
                      borderRadius: "5px",
                      width: "100%",
                      backgroundColor: !isSectionEnabled ? "#e9ecef" : "white",
                      cursor: !isSectionEnabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <option value="">Select Section</option>
                    {optionSection.map((section, index) => (
                      <option key={index} value={section.value}>
                        {section.label}
                      </option>
                    ))}
                  </select>
                </Col>
  

                {/* <Col
                  xs={12}
                  lg={3}
                  className="d-flex justify-content-end align-items-center gap-2 mt-4"
                >
                  <select
                    className="form-select"
                    value={orientation}
                    onChange={(e) => setOrientation(e.target.value)}
                    // style={{ borderRadius: "5px", width: "140px" }}
                  >
                    <option value="vertical">Vertical</option>
                    <option value="horizontal">Horizontal</option>
                  </select>

                  <Button
                    className="btn btn-primary"
                    onClick={downloadIDCards}
                    disabled={isDownloading}
                    style={{
                      padding: "6px 12px",
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {isDownloading ? (
                      "Generating..."
                    ) : (
                      <>
                        <i className="fa-solid fa-download"></i>
                        {selectedStudents.length > 0 &&
                          `(${selectedStudents.length})`}
                      </>
                    )}
                  </Button>
                </Col> */}

                <Col
                  xs={12}
                  sm={5}
                  lg={1}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  {/* <div style={{ marginTop: "5px" }}>
                    <InfoPill left="Total Students" right={filteredBody?.length} />
                    {selectedStudents.length > 0 && (
                      <InfoPill left="Selected" right={selectedStudents.length} />
                    )}
                  </div> */}
                </Col>

                {/* <Col
                  xs={12}
                  lg={3}
                  className="d-flex justify-content-end align-items-center gap-2 mt-4"
                >
                  <div className="dropdown">
                    <Button
                      className="btn btn-primary dropdown-toggle"
                      onClick={() => {}}
                      disabled={isDownloading}
                      style={{
                        padding: "6px 12px",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {isDownloading ? (
                        "Generating..."
                      ) : (
                        <>
                          <i className="fa-solid fa-download"></i> 
                          {selectedStudents.length > 0 &&
                            `(${selectedStudents.length})`}
                        </>
                      )}
                    </Button>
                    <ul className="dropdown-menu">
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setOrientation("vertical");
                            setTimeout(() => downloadIDCards(), 100);
                          }}
                        >
                          <i className="fa-solid fa-arrow-up me-2"></i> Portrait
                          (Vertical)
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setOrientation("horizontal");
                            setTimeout(() => downloadIDCards(), 100);
                          }}
                        >
                          <i className="fa-solid fa-arrow-right me-2"></i>{" "}
                          Landscape (Horizontal)
                        </button>
                      </li>
                    </ul>
                  </div>
                </Col> */}
                <Col
                  xs={12}
                  lg={5}
                  className="d-flex justify-content-end align-items-center gap-2"
                >
                  {(userInfo?.userrole === "SYS_ADMIN" ||
                    userInfo?.userrole === "ADMIN" ||
                    canCreate) && (
                      <Button
                        className="btn add-new-button"
                        variant=""
                        disabled={isCurrentSession === false ? true : false}
                        onClick={() => StudentAddmissionregistration(true)}
                        style={{
                          padding: "6px 12px",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        New Admission
                      </Button>
                    )}
                  <div className="dropdown">
                    <Button
                      className="btn btn-primary dropdown-toggle"
                      disabled={isDownloading}
                      style={{
                        padding: "6px 12px",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {isDownloading ? (
                        "Generating..."
                      ) : (
                        <>
                          <i className="fa-solid fa-download"></i> Download
                        </>
                      )}
                    </Button>

                    <ul className="dropdown-menu">
                      {/* ALL DATA */}
                      <li className="position-relative group-submenu">
                        <button
                          className="dropdown-item d-flex justify-content-between align-items-center"
                          type="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            {/* All Data SVG Icon */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M2 2h12v3H2V2zm0 4h12v3H2V6zm0 4h12v3H2v-3z" />
                            </svg>
                            Download Id Card
                          </span>

                          {/* Arrow Icon */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10.854 8.354a.5.5 0 0 0 0-.708L7.672 4.464a.5.5 0 1 0-.708.708L9.793 8l-2.829 2.828a.5.5 0 1 0 .708.708l3.182-3.182z"
                            />
                          </svg>
                        </button>

                        {/* SUB MENU */}
                        <ul className="submenu dropdown-menu">
                          <li>
                            <button
                              className="dropdown-item d-flex align-items-center gap-2"
                              onClick={() => {
                                setOrientation("vertical");
                                downloadIDCards("vertical");
                              }}
                            >
                              {/* Vertical SVG */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 1l3 3H9v8H7V4H5l3-3z" />
                              </svg>
                              Vertical
                            </button>
                          </li>

                          <li>
                            <button
                              className="dropdown-item d-flex align-items-center gap-2"
                              onClick={() => {
                                setOrientation("horizontal");
                                downloadIDCards("horizontal");
                              }}
                            >
                              {/* Horizontal SVG */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                              >
                                <path d="M1 8l3-3v2h8V5l3 3-3 3V9H4v2L1 8z" />
                              </svg>
                              Horizontal
                            </button>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Table striped className="data-table student-checkbox-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </>
  );
};

export default StudentAddmissionList;
